module.exports = __webpack_public_path__ + "img/gurukultek_logo.2fcc72b6.jpeg";